import React from 'react';
import { ExternalLink } from 'lucide-react';
import { useDispatch, useSelector } from 'react-redux';
import Modal from 'tailwind-components/Modal/Modal';
import { NEO_SUBMISSION_FORM_URL } from 'helpers/neo/neo';
import { setIsNeoSubmissionModalOpen } from 'state/actions/appointments';
import Button from 'tailwind-components/Button';

/**
 * pop-up shown after a Neo request is sent, pointing the agent to the form that finishes the submission
 */
export default function NeoSubmissionModal() {
  const dispatch = useDispatch();
  const isOpen = useSelector(
    state => state.appointments.isNeoSubmissionModalOpen
  );

  const closeModal = () => dispatch(setIsNeoSubmissionModalOpen(false));

  if (!isOpen) return null;

  return (
    <Modal active size='medium' title='One last step' closeModal={closeModal}>
      <div className='flex flex-col gap-3 text-left'>
        <p className='text-base font-semibold m-0'>
          Your request was sent successfully.
        </p>
        <p className='m-0'>
          To finish the submission of your request, please complete the Neo
          Insurance form using the link below. Neo will then send you the
          onboarding instructions to complete your appointment.
        </p>
      </div>

      <div className='flex flex-col-reverse lg:flex-row justify-end gap-3 mt-6 w-full'>
        <Button
          className='flex-1'
          variant='secondary'
          text='Close'
          onClick={closeModal}
        />
        <Button
          // the global unlayered `a` rule would otherwise win over the text color and width utilities
          className='flex-1 w-full! text-white! no-underline hover:no-underline'
          variant='primaryDarkened'
          href={NEO_SUBMISSION_FORM_URL}
          target='_blank'
          rel='noopener noreferrer'
          icon={<ExternalLink size={18} />}
          text='Complete Neo form'
        />
      </div>
    </Modal>
  );
}
